<template>
    <span class="timer" v-if="currentTime">{{ currentTime }}</span>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'timer',

        computed: mapState('appointment', ['appointmentData']),

        data() {
            return {
                interval: null,
                currentTime: null,
            };
        },

        mounted() {
            this.setCurrentTime();

            this.interval = setInterval(this.setCurrentTime, 1000);
        },

        destroyed() {
            clearInterval(this.interval);
        },

        methods: {
            setCurrentTime() {
                if (!this.appointmentData || !this.appointmentData.expires) {
                    return this.expired();
                }

                const now = window.moment();

                if (this.appointmentData.expires.isBefore(now)) {
                    return this.expired();
                }

                const time = window.moment(
                    this.appointmentData.expires.diff(now)
                );

                if (time.minute() <= 0 && time.second() <= 0) {
                    this.expired();
                } else {
                    this.currentTime = time.format('mm:ss');
                }
            },

            expired() {
                clearInterval(this.interval);

                this.$emit('expired');
            },
        },
    }
</script>
